const { name, version } = __serviceInfo__;
export { name as serviceName, version };
